import React, { useState, Children, isValidElement, cloneElement } from 'react';
import ButtonGroupStyled from './bundle.esm2.js';
import Button from './Button/bundle.esm.js';
import { defaultFunction, filteredChildren } from '../../utils/bundle.esm2.js';

const ButtonGroup = (props) => {
  const { children, className, onChange = defaultFunction } = props;
  const { defaultActive, active, ariaLabelledBy } = props;
  const [internalActive, setInternalActive] = useState(defaultActive != null ? defaultActive : 0);
  const renderChildren = () => {
    return Children.map(
      filteredChildren(children, Button),
      (child, index) => {
        var _a, _b;
        if (!isValidElement(child)) {
          return;
        }
        const originalOnClick = (_a = child.props.onClick) != null ? _a : defaultFunction;
        const enhancedOnClick = (e) => {
          var _a2;
          const newValue = child.props.value;
          e.target.value = newValue;
          onChange(e);
          originalOnClick(e);
          setInternalActive((_a2 = child.props.id) != null ? _a2 : index);
        };
        return cloneElement(child, {
          onClick: enhancedOnClick,
          __active__: ((_b = child.props.id) != null ? _b : index) === (active != null ? active : internalActive)
        });
      }
    );
  };
  return /* @__PURE__ */ React.createElement(ButtonGroupStyled, {
    className: `ButtonGroup ${className}`,
    "aria-labelledby": ariaLabelledBy
  }, renderChildren());
};
ButtonGroup.Button = Button;
ButtonGroup.defaultProps = {
  className: ""
};

export { ButtonGroup as default };
//# sourceMappingURL=bundle.esm.js.map
